import React from 'react'
import { FaPencil } from "react-icons/fa6";
import './Conponents.css'; // <--- CSS Import

function Conponents() {
  return (
    <div className="comp-container">
      <div className="comp-header">
        <h2>Components </h2>
      </div>
      <div className="comp-form-box">
        <h5 className="comp-subtitle">GUM WORK COMPOSITE</h5>
        <div className="comp-form-row">
          <label htmlFor="pricingFor" className="comp-label">
            Presence *
          </label>
          <select
            id="pricingFor"
            name="pricingFor"
            className="comp-select"
          >
            <option value="individual">Individual</option>
            <option value="group">Group</option>
          </select>
        </div>
      </div>
      <br />
      <div>
        <button className="comp-save-btn">
          <FaPencil /> Save
        </button>
      </div>
    </div>
  )
}

export default Conponents